import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminTermsListHeader = ({
  orderBy,
  order,
  terms,
  selectedTerms,
  handleChangeOrder,
  handleSelectTerm,
}) => {
  const intl = useIntl();

  const changeOrder = (e, field) => {
    e.preventDefault();
    handleChangeOrder(field, order === 'asc' ? 'desc' : 'asc');
  };

  return (
    <tr>
      <th className="selector">
        {terms.length > 0 && (
          <Input
            type="checkbox"
            name="selected-user"
            value="all"
            checked={selectedTerms.length === terms.length}
            onChange={handleSelectTerm}
          />
        )}
      </th>
      <th className={`th-sortable${orderBy === 'name' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'name'); }}>
          {intl.formatMessage({ defaultMessage: 'Name' })}
          {' '}
          {orderBy === 'name' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th className={`th-sortable${orderBy === 'files' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'files'); }}>
          {intl.formatMessage({ defaultMessage: 'Files' })}
          {' '}
          {orderBy === 'files' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Blocked' })}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

AdminTermsListHeader.propTypes = {
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  terms: PropTypes.array.isRequired,
  selectedTerms: PropTypes.array.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
  handleSelectTerm: PropTypes.func.isRequired,
};

export default AdminTermsListHeader;
